import { type Question } from '@/types'

import { generateId } from '../utils'
import { getMatrixQuestionInfo } from './getMatrixQuestionInfo'
import { getMatrixRowQuestionInfo } from './getMatrixRowQuestionInfo'
import { getMatrixRowQuestionInfoByRowOrder } from './getMatrixRowQuestionInfoByRowOrder'

type Props =
  | {
      questionId?: number
      rowOrder?: number
      classes: string
      description: string
      id: string
      title: string
      formIndex?: string
    }
  | undefined

export const getQuestionInfo = (
  questions: Question[],
  identifier: string
): Props => {
  if (!identifier) {
    return {
      classes: '',
      description: '',
      id: generateId(),
      title: '',
      formIndex: '',
    }
  }

  const combinedRegex = /(QR(\d+)_(\d+))|(Q(\d+))|(R(\d+))/g
  const matches = identifier?.matchAll(combinedRegex)

  for (const match of matches) {
    if (match?.[2] && match?.[3]) {
      const questionId = Number(match?.[2])
      const rowOrder = Number(match?.[3])
      return {
        ...getMatrixRowQuestionInfoByRowOrder(questions, questionId, rowOrder),
        questionId,
        rowOrder,
      }
    } else if (match?.[5]) {
      return getMatrixQuestionInfo(questions, match?.[5])
    } else if (match?.[6]) {
      return getMatrixRowQuestionInfo(questions, match?.[6])
    }
  }

  throw new Error('No valid identifier format found')
}
